import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';
import {InMemoryWebApiModule} from 'angular-in-memory-web-api';
import {InMemoryDataService} from './shared/inmemory-db/inmemory-db.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {StorageServiceModule} from 'angular-webstorage-service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpModule} from '@angular/http';
import {DataTablesModule} from 'angular-datatables';
import {UserService} from './shared/services/members/user.service';
import {SessionStorageService} from './shared/services/session-storage.service';
import {SweetAlertService} from 'ngx-sweetalert2';
import {SocketService} from './shared/services/socket.service';
import {WebSocketService} from './shared/services/websocket.service';
import {WebSocketMessageService} from './shared/services/websocket-message.service';
import {ExportAsModule} from 'ngx-export-as';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        SharedModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        BrowserAnimationsModule,
        InMemoryWebApiModule.forRoot(InMemoryDataService, {passThruUnknownUrl: true}),
        AppRoutingModule,
        StorageServiceModule,
        HttpModule,
        HttpClientModule,
        DataTablesModule,
        ExportAsModule
    ],
    providers: [
        UserService,
        SessionStorageService,
        SweetAlertService,
        SocketService,
        WebSocketService,
        WebSocketMessageService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}

